import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { AppNavSidebar } from '@/components/AppNavSidebar';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Header } from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import type { AuthUser } from '../utils/auth';

interface RouterContext {
  auth: {
    user: AuthUser | null;
    isAuthenticated: boolean;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  const { isAuthenticated } = useAuth();
  const isContactSupport = window.location.pathname === '/contact-support';

  if (!isAuthenticated || isContactSupport) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen flex-col bg-neutral-50 font-sans">
      <Header />
      <div className="flex min-h-0 flex-1 pt-14">
        <AppNavSidebar />
        <main className="min-h-0 flex-1 overflow-y-auto px-2">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-muted p-8">
      <h1 className="mb-4 text-5xl font-bold text-text-primary">404</h1>
      <p className="mb-8 text-center text-xl text-text-secondary">Page not found</p>
      <Link to="/project-settings/employee-project-models" className={cn(buttonVariants())}>
        Go to Project Settings
      </Link>
    </div>
  );
}
